import { Component, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { Location } from '@angular/common';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-stall-uers',
  templateUrl: './stall-uers.component.html',
  styleUrls: ['./stall-uers.component.scss'],
  standalone: false,
})
export class StallUersComponent {

  so_id: any;

  userForm: FormGroup;
  usersList: any[] = [];

  isLoading = false;
  isSubmitting = false;

  private destroyRef = inject(DestroyRef);

  roleOptions = [
    'Owner',
    'Manager',
    'Sales',
    'Support',
    'Other'
  ];

  constructor(
    private fb: FormBuilder,
    private service: ServicesService,
    private toastr: ToastrService,
    private location: Location,
    private route: ActivatedRoute
  ) {

    this.userForm = this.fb.group({
      name: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(\s*\S+\s*)+$/)
      ]),
      mobile: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/)
      ]),
      role: new FormControl('', [
        Validators.required
      ])
    });
  }

  ngOnInit(): void {
    this.so_id = this.route.snapshot.paramMap.get('so_id');
    this.loadUsers();
  }

  goBack(): void {
    this.location.back();
  }

  loadUsers() {
    this.isLoading = true;

    this.service
      .get_stall_users(this.so_id)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: (res: any) => {
          this.usersList = res?.data || [];
        },
        error: () => {
          this.usersList = [];
        }
      });
  }

  onSubmit() {

    if (this.userForm.invalid) {
      this.toastr.error(
        'Please fill all required fields correctly'
      );
      return;
    }

    this.isSubmitting = true;

    const payload = {
      so_id: this.so_id,
      ...this.userForm.value
    };

    this.service
      .add_stall_users(payload)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => (this.isSubmitting = false))
      )
      .subscribe({
        next: () => {
          this.toastr.success(
            'User added successfully'
          );

          this.userForm.reset();

          this.loadUsers();
        },
        error: () => {
          this.toastr.error(
            'Failed to add user'
          );
        }
      });
  }
}